"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.INPUT = exports.INPUT_STYLE_OBJECT = exports.SUFFIX = exports.PREFIX = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var getPadding = function getPadding(a) {
  var b = a.styleType,
      c = a.small;
  return "BASIC" === b ? c ? "5px 10" : 10 : "PRIMARY" === b ? "".concat(c ? 5 : 10, "px 15") : "TEXT" === b ? 0 : "";
},
    DEFAULT = function DEFAULT(a) {
  var b = a.styleType,
      c = a.small;
  return {
    border: "TEXT" === b ? 0 : "1px solid ".concat(_vars.COLOURS.grey.mischka.russian),
    borderRadius: "6px",
    color: "black",
    caretColor: _vars.COLOURS.cyan.jungleGreen.monkey,
    fontSize: _vars.FONT_SIZES[c ? "small" : "default"],
    padding: "".concat(getPadding({
      styleType: b,
      small: c
    }), "px"),
    width: "100%",
    lineHeight: "100%",
    boxSizing: "border-box",
    minHeight: "".concat(c ? 40 : 50, "px"),
    background: "BASIC" === b ? "rgba(0, 0, 0, 0)" : "default",
    ":focus": {
      background: "BASIC" === b ? _vars.COLOURS.grey.athens.bigFat : "default",
      border: "TEXT" === b ? 0 : "1px solid ".concat(_vars.COLOURS.mono.black),
      outline: "none"
    },
    "::placeholder": {
      textIndent: "3px"
    },
    ':not([value=""])': {
      background: "BASIC" === b ? _vars.COLOURS.grey.athens.bigFat : "default"
    }
  };
},
    DISABLED = {
  background: _vars.COLOURS.grey.athens.zeus,
  color: _vars.COLOURS.grey.jumbo,
  cursor: "default",
  pointerEvents: "none"
},
    INVALID = {
  border: "1px solid ".concat(_vars.COLOURS.red.thunderBird)
},
    PREFIX = {
  paddingLeft: "55px !important"
};

exports.PREFIX = PREFIX;
var SUFFIX = {
  paddingRight: "55px !important"
};
exports.SUFFIX = SUFFIX;

function getStyle(a, b) {
  return a ? b : {};
}

var INPUT_STYLE_OBJECT = function INPUT_STYLE_OBJECT(a) {
  var b = a.disabled,
      c = a.valid,
      d = a.hasPrefix,
      e = a.hasSuffix,
      f = a.styleType,
      g = void 0 === f ? "PRIMARY" : f,
      h = a.small;
  return _objectSpread({}, DEFAULT({
    styleType: g,
    small: h
  }), {}, getStyle(b, DISABLED), {}, getStyle(!(!(void 0 !== c) || c), INVALID), {}, getStyle(d, PREFIX), {}, getStyle(e, SUFFIX));
};

exports.INPUT_STYLE_OBJECT = INPUT_STYLE_OBJECT;

var INPUT = function INPUT(a) {
  return (0, _cxs["default"])(INPUT_STYLE_OBJECT(a));
};

exports.INPUT = INPUT;